<template>
    <div>
        <div v-if="blnLoadingData">
            <p>{{ $t('general.loadingData') }} {{Math.round(getProgress)}}%</p>

            <div class="compare-data_progess-bar">
                <div class="compare-data_progress-bar-value" :style="{width: getProgress + '%'}">

                </div>
            </div>

        </div>
        <div v-else-if="blnSavingAprons">
            <p>{{ $t('general.savingData') }} {{Math.round(intSubmitted / apronInFocus.length * 100)}}%</p>

            <div class="compare-data_progess-bar">
                <div class="compare-data_progress-bar-value" :style="{width: (intSubmitted / apronInFocus.length * 100) + '%'}">

                </div>
            </div>

        </div>

        <div class="add-edit-apron" v-else>
            <!----------------- MANUFACTURER-------------------->
            <div class="add-edit-apron_row">
                <div class="add-edit-apron_propertybox">

                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label for="manufacturer" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.manufacturer') }}*</label>
                        <unique-prop-counter v-if="blnMultiEdit &&  Object.keys(selectedUniquePropValues.manufacturers ).length > 1" :selectedValue="selectedUniquePropValues.manufacturers " />
                    </div>

                    <select id="manufacturer" v-model="emptyApron.model.manufacturerID">
                        <option v-if="blnMultiEdit && emptyApron.model.manufacturerID == 0" disabled :value="0">--{{ $t('addEditApron.multipleManufacturesSelected') }}--</option>
                        <option v-else disabled :value="0">--{{ $t('general.pleaseSelect') }}--</option>
                        <optgroup v-if="cptPopularManufacturers.length > 0" label="Suggested">
                            <option v-for="(man, index) in cptPopularManufacturers" v-bind:key="index" :value="man.manufacturerID">{{man.name}}</option>
                        </optgroup>

                        <optgroup label="Alphabetical">
                            <option v-for="(man, index) in lstManufacturers" v-bind:key="index" :value="man.manufacturerID">{{man.name}}</option>
                        </optgroup>

                    </select>
                </div>
                <!----------------- MODELS -------------------->
                <div class="add-edit-apron_propertybox">

                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label for="model" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.model') }}*</label>
                        <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.models ).length > 1"
                                             :selectedValue="selectedUniquePropValues.models " />
                    </div>

                    <div v-if="blnMultiEdit && emptyApron.model.manufacturerID == 0">
                        <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleManufacturesSelected') }}
                    </div>

                    <select v-else id="model" v-model="emptyApron.apronModelID">
                        <option v-if="blnMultiEdit == false " disabled :value=0>-- {{ $t('general.pleaseSelect') }} --</option>
                        <option v-else disabled :value=-1>-- {{ $t('addEditApron.multipleModelsSelected') }} --</option>

                        <optgroup v-if="cptUncategorized.length > 0" :label="$t('addEditApron.uncategorized')">
                            <option v-for="(mod, index) in cptUncategorized" :selected="lstModelsForManufacturer.length == 1" :key="index" :value="mod.apronModelID">{{mod.name}}</option>
                        </optgroup>
                        <optgroup v-if="cptAprons.length > 0" :label="$t('addEditApron.apronsSkirtsVests')">
                            <option v-for="(mod, index) in cptAprons" :selected="lstModelsForManufacturer.length == 1" :key="index" :value="mod.apronModelID">{{mod.name}}</option>
                        </optgroup>
                        <optgroup v-if="cptAccessories.length > 0" :label="$t('addEditApron.thyroidCollarsOthers')">
                            <option v-for="(mod, index) in cptAccessories" :selected="lstModelsForManufacturer.length == 1" :key="index" :value="mod.apronModelID">{{mod.name}}</option>
                        </optgroup>
                    </select>
                    <p v-if="blnShowWarning === true" class="color-red small m-0">{{ $t('addEditApron.ModelConvertedToDefault') }}</p>
                </div>
            </div>

            <!----------------- SERIAL NUMBER -------------------->
            <div v-if="blnMultiEdit == false" class="add-edit-apron_propertybox">
                <label for="SN" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.serial') }} *</label>
                <input id="SN" type="text" v-model="emptyApron.serialNumber" />
            </div>

            <!----------------- SIZE -------------------->

            <div class="add-edit-apron_propertybox">

                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="Size" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.size') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.sizes).length > 1" :selectedValue="selectedUniquePropValues.sizes " />
                </div>

                <div v-if="blnMultiEdit && emptyApron.size == -2">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleSizesSelected') }}
                </div>

                <size-dropdown v-model="emptyApron.size" id="Size" :manufacturer-id="emptyApron.model.manufacturerID"></size-dropdown>

                <div v-for="(adj, index) in emptyApron.sizeAdjustments" :key="index">

                    <div v-if="adj.adjustmentType == 1">
                        <label :for="'Adj'+index">{{ $t('configurator.lengthAdjustment') }}</label>
                        <input :id="'Adj'+index" type="number" step="5" v-model="adj.parameter1" />cm
                    </div>

                    <div v-if="adj.adjustmentType == 2">
                        <label :for="'Adj'+index">{{ $t('configurator.extraOverlap') }}</label>
                        <input :id="'Adj'+index" type="number" step="3" min="0" v-model="adj.parameter1" />cm
                    </div>

                    <div v-if="adj.adjustmentType == 3">
                        <label :for="'Adj'+index">{{ $t('configurator.armholeAdjustment') }}</label>
                        <input :id="'Adj'+index" type="number" step="1" max="3" min="-3" onkeyup="if(this.value > this.max) this.value = this.max" v-model="adj.parameter1" />cm
                    </div>

                </div>
            </div>


            <!----------------- COLOR SELECTION -------------------->
            <div class="add-edit-apron_propertybox">
                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="fabric" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.fabricColor') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.fabricColors ).length > 1" :selectedValue="selectedUniquePropValues.fabricColors " />
                </div>

                <div v-if="blnIsScanflex == false">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.onlyAvaibleForScanFlex') }}
                </div>

                <div v-if="emptyApron.apronModelID == 0 && blnMultiEdit == false && blnIsScanflex">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.selectModelFirst') }}
                </div>

                <div v-if="emptyApron.apronModelID == -1 && blnMultiEdit && blnIsScanflex">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleModelsSelected') }}
                </div>

                <div v-else-if="blnMultiEdit && cptNumberOfSelectedFabrics > 1  && blnIsScanflex && emptyApron.apronModelID != 0">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleColorsSelected') }}
                </div>

                <div v-else-if="emptyApron.apronModelID != 0 && blnIsScanflex && (lstFabricColors == null || lstFabricColors.length == 0) ">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.notAvailable', [$t('addEditApron.fabrics')]) }}
                </div>

                <div v-if="blnIsScanflex" class="add-edit-apron_color-pills-container">
                    <div v-for="(fab, index) in lstFabricColors" :key="index" @click="emptyApron.fabricColorID = fab.fabricColorID" class=" border label small-label text-center color-swatch-pill" :class="{pillSelected: emptyApron.fabricColorID == fab.fabricColorID}">
                        <span :style="{background: fab.hex}"></span>{{fab.name}}
                    </div>
                </div>
            </div>
            <!----------------- RIBBON SELECTION -------------------->
            <div class="add-edit-apron_propertybox">
                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="fabric" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.ribbonColor') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.ribbonColors ).length > 1" :selectedValue="selectedUniquePropValues.ribbonColors " />
                </div>

                <div v-if="blnIsScanflex == false">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.onlyAvaibleForScanFlex') }}
                </div>

                <div v-if="emptyApron.apronModelID == 0 && blnMultiEdit == false && blnIsScanflex">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.selectModelFirst') }}
                </div>

                <div v-if="emptyApron.apronModelID == -1 && blnMultiEdit && blnIsScanflex">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleModelsSelected') }}
                </div>

                <div v-else-if="blnMultiEdit && cptNumberOfSelectedRibbons > 1 && blnIsScanflex && emptyApron.apronModelID != 0">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.multipleColorsSelected') }}
                </div>

                <div v-else-if="emptyApron.apronModelID != 0 && blnIsScanflex && (lstRibbonColors == null || lstRibbonColors.length == 0)">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.notAvailable', [$t('addEditApron.ribbons')]) }}
                </div>

                <div v-if="blnIsScanflex" class="add-edit-apron_color-pills-container">
                    <div v-for="(fab, index) in lstRibbonColors" :key="index" @click="emptyApron.ribbonColorID = fab.ribbonColorID" class="border label small-label text-center ribbon-swatch-pill" :class="{pillSelected: emptyApron.ribbonColorID == fab.ribbonColorID}">
                        <span :style="{background: 'url(...' + fab.previewFilePath + ')' + 'no-repeat' ,  backgroundSize: 'cover' }">
                        </span>
                        <img :src="fab.previewFilePath" />
                        {{fab.name}}
                    </div>
                </div>
            </div>
            <!----------------- PRODUCTION DATE -------------------->
            <div class="add-edit-apron_propertybox">
                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="dateProduced" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.productionDate') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.productionDates ).length > 1" :selectedValue="selectedUniquePropValues.productionDates " />
                </div>

                <input id="dateProduced" type="month" v-model="cptProductionDate" />
            </div>
            <!----------------- USER NAME -------------------->
            <div class="add-edit-apron_propertybox">

                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="name" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.nameOfUser') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.users ).length > 1" :selectedValue="selectedUniquePropValues.users " />
                </div>
                <input v-if="blnMultiEdit && emptyApron.nameOfUser == '' " id="name" type="text" v-model="emptyApron.nameOfUser" :placeholder="$t('addEditApron.multipleUsersSelected') + '...' " />
                <input v-else id="name" type="text" v-model="emptyApron.nameOfUser" />
            </div>
            <!----------------- DEPARTMENT -------------------->
            <div class="add-edit-apron_propertybox">
                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label for="dept" class="add-edit-apron_propertybox-label">{{ $tc('addEditApron.department', 1) }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.departments ).length > 1" :selectedValue="selectedUniquePropValues.departments " />
                </div>
                <p>{{ $t('addEditApron.manageDepartments') }} <router-link class="small-button color-magenta" :to="{ name: 'Settings', params: { tabToOpen: 'dept' } }">{{ $t('addEditApron.settingsPage') }}</router-link></p>

                <select id="dept" v-model="emptyApron.departmentID">
                    <option v-if="blnMultiEdit" :value="null" disabled>--{{ $t('addEditApron.multipleDepartmentSelected') }}--</option>
                    <option v-else :value="null" disabled>--{{ $t('general.pleaseSelect') }}--</option>
                    <option v-for="(dep, index) in lstDepartments" :key="index" :value="dep.departmentID">{{dep.name}}</option>
                </select>
            </div>
            <div class="add-edit-apron_row">
                <!----------------- MONOGRAM LINE 1 -------------------->
                <div class="add-edit-apron_propertybox">
                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label for="mono1" class="add-edit-apron_propertybox-label">{{ $t('addEditApron.monogram') }}<span v-if="blnIsScanflex"> {{ $t('addEditApron.line1') }}</span> </label>
                        <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.monogramLines1).length > 1" :selectedValue="selectedUniquePropValues.monogramLines1 " />
                    </div>

                    <input v-if="blnMultiEdit && emptyApron.monogramLine1 == ''" id="mono1" type="text" v-model="emptyApron.monogramLine1" :placeholder=" $t('addEditApron.multipleMonogramsSelected')" />
                    <input v-else id="mono1" type="text" v-model="emptyApron.monogramLine1" :placeholder=" $t('addEditApron.exampleName')" />

                </div>
                <!----------------- MONOGRAM LINE 2 -------------------->
                <div class="add-edit-apron_propertybox">
                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label for="mono2" class="add-edit-apron_propertybox-label">{{ $t('configurator.monogramLine') }} 2</label>
                        <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.monogramLines2).length > 1" :selectedValue="selectedUniquePropValues.monogramLines2" />
                    </div>

                    <div v-if="blnIsScanflex == false">
                        <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.onlyAvaibleForScanFlex') }}
                    </div>

                    <div v-if="blnIsScanflex ">
                        <input v-if="blnMultiEdit && emptyApron.monogramLine2 == ''" id="mono2" type="text" v-model="emptyApron.monogramLine2" :placeholder=" $t('addEditApron.multipleMonogramsSelected')" />
                        <input v-else id="mono2" type="text" v-model="emptyApron.monogramLine2" :placeholder=" $t('addEditApron.exampleDepartment')" />
                    </div>
                </div>
            </div>
            <!----------------- MATERIAL -------------------->
            <div class="add-edit-apron_propertybox">

                <div class="add-edit-apron_propertybox-label-wrapper">
                    <label class="add-edit-apron_propertybox-label">{{ $t('configurator.material') }}</label>
                    <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.materials).length > 1" :selectedValue="selectedUniquePropValues.materials" />
                </div>

                <div v-if="blnIsScanflex ">

                    <select v-model="emptyApron.internalMaterial" class="w-100">
                        <option :value=-1 disabled>--{{ $t('general.pleaseSelect') }}--</option>
                        <option :value=2>Opaque Action (Light Lead)</option>
                        <option :value=1>Opaque Fusion (No Lead)</option>
                    </select>
                </div>
                <div v-else-if="blnIsScanflex == false">
                    <b-icon-info-circle-fill class="color-blue mr-1" /> {{ $t('addEditApron.onlyAvaibleForScanFlex') }}
                </div>

            </div>
            <!----------------- PB EQUIVALENCE (FRONT) -------------------->
            <div class="add-edit-apron_row">
                <div class="add-edit-apron_propertybox">
                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label class="add-edit-apron_propertybox-label">{{ $t('addEditApron.pbEquivalence') }} ({{ $t('addEditApron.front') }})</label>
                        <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.pbEqFront).length > 1" :selectedValue="selectedUniquePropValues.pbEqFront" />
                    </div>
                    <select v-model="emptyApron.pbEqFront" class="w-100">
                        <option v-if="blnMultiEdit && emptyApron.pbEqFront == -2" :value=-2 disabled>--{{ $t('addEditApron.differentValuesSelected') }}--</option>
                        <option v-else :value=-2 disabled>--{{ $t('general.pleaseSelect') }}--</option>
                        <option v-if="emptyApron.pbEqFront == -1" :value=-1 disabled>--{{ $t('general.pleaseSelect') }}--</option>
                        <option :value=2>0.25mm</option>
                        <option :value=3>0.35mm</option>
                        <option :value=5>0.50mm</option>
                    </select>
                </div>
                <!----------------- PB EQUIVALENCE (BACK) -------------------->
                <div v-if="typeof emptyApron.model != 'undefined' && (emptyApron.model.category == 2 || emptyApron.model.category == 0)" class="add-edit-apron_propertybox">

                    <div class="add-edit-apron_propertybox-label-wrapper">
                        <label class="add-edit-apron_propertybox-label">{{ $t('addEditApron.pbEquivalence') }} ({{ $t('addEditApron.back') }})</label>
                        <unique-prop-counter v-if="blnMultiEdit && Object.keys(selectedUniquePropValues.pbEqBack).length > 1" :selectedValue="selectedUniquePropValues.pbEqBack" />
                    </div>

                    <select v-model="emptyApron.pbEqBack" class="w-100">
                        <option v-if="blnMultiEdit && emptyApron.pbEqBack == -2" :value=-2 disabled>--{{ $t('addEditApron.differentValuesSelected') }}--</option>
                        <option v-else :value=-2 disabled>--{{ $t('general.pleaseSelect') }}--</option>
                        <option v-if="emptyApron.pbEqBack == -1" :value=-1 disabled>--{{ $t('general.pleaseSelect') }}--</option>
                        <option :value=2>0.25mm</option>
                        <option :value=3>0.35mm</option>
                        <option :value=5>0.50mm</option>
                    </select>
                </div>
            </div>
            <input type="number" v-model="apronIDfromProp" class="d-none" />
            <div class="mt-4 mb-4 text-right">
                <!--<label v-if="allowSave == false">Fields marked with * are mandatory.</label>-->
                <navigation-button mode="save" :allow-press="allowSave == true" @button-clicked="submitApronForm()"></navigation-button>
            </div>

        </div>
    </div>
</template>

<script>
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import UniquePropCounter from "@/private/components/UI-elements/UniquePropCounter.vue";
    import axios from 'axios'
    import { mapState } from 'vuex';
    import { POST_submitApronForm, toHTML5month, SizeToString, MaterialToString, PbEqToString } from '@/scripts/General.js'
    import Bus from '@/Bus.js';

    import SizeDropdown from "@/private/components/UI-elements/SizeDropdown.vue";

    export default {
        name: 'AddEditApron',
        data: function () {

            return {
                blnLoadingData: true,
                apronInFocus: [],
                emptyApron: {},
                apronIDfromProp: -1,
                mappedKeyValues: {},
                selectedUniquePropValues: {},
                getProgress: 0,
                postProgress: 0,
                lengthOfValues: 3,
                strModelConvertedToDefault: '',
                intErrorCount: 0,
                intSubmitted: 0,
				blnSavingAprons: false,
                blnShowWarning: false,
                blnMountDone: false,
            }

        },
        components: {
            NavigationButton,
            SizeDropdown,
            UniquePropCounter
        },
        props: {
            apronID: {
                //type: Number,
                default: -1
            }
        },
        created: async function () {
			this.apronIDfromProp = this.apronID;
			this.compareSelected();
        },
        mounted: function () {
        },
        methods: {

            submitApronForm: function () {

                this.intErrorCount = 0;
                this.intSubmitted = 0;
				this.blnSavingAprons = true
                var blnIsNewItem

                //Save the apron or add it if necessary
                this.apronIDfromProp == -1 ? blnIsNewItem = true : blnIsNewItem = false

                for (var i = 0; i < this.apronInFocus.length; i++) {
					let myApr = this.apronInFocus[i]
					POST_submitApronForm(this, myApr, this.onSubmitApronFormComplete, this.onSubmitError, blnIsNewItem)
				}

            },
            onSubmitApronFormComplete: function (response) {
                //Update open apron with server data
                //this.apronInFocus = response.data

                this.intSubmitted += 1;

                //Let parent component know
				Bus.$emit('apron-saved', response.data)

				this.checkIfDone()
                
            },
            onSubmitError: function () {
				this.intSubmitted += 1
                this.intErrorCount += 1

                this.checkIfDone()

            },
            checkIfDone: function () {
				if (this.intSubmitted == this.apronInFocus.length && this.intErrorCount == 0) {
					//We are done. Close the modal
					this.blnSavingAprons = false
					Bus.$emit('close-modal');
					return;
				}

				if (this.intSubmitted == this.apronInFocus.length && this.intErrorCount > 0) {

					alert('Not all items could be saved.')
					this.blnSavingAprons = false
					//Close the modal
					Bus.$emit('close-modal');
				}
            },
            getEmptyApron: async function () {
                return await axios.get('/dashboard/getEmptyApronObject')
                    .then((response) => {

                        this.emptyApron = response.data
                        return ('ready');

                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            getAprons: async function () {

                const Percentage = 100 / this.apronIDfromProp.length

                for (var i = 0; i < this.apronIDfromProp.length; i++) {

                    var params = { apronID: this.apronIDfromProp[i] }
                    //We have a specific apron to load
                    await axios.get('/dashboard/getApronById', { params })
                        .then((response) => {
                            this.getProgress = this.getProgress + Percentage
                            this.apronInFocus.push(response.data);

                        })
                        .catch(function (error) {
                            alert(error);
                        });
                }
                return ('ready')
            },
            compareSelected: async function () {
                this.blnLoadingData = true

                //wait for al data to be loaded
                const x = [await this.getEmptyApron(), await this.getAprons()]
				await this.$store.dispatch('GET_ApronModelsByManufacturer', this.emptyApron.model.manufacturerID)

                //all data loaded complete
                if (x.length == 2) {

                    //single apron selected
                    if (this.blnMultiEdit == false) {
                        //fill empty with known value's
                        this.emptyApron = this.apronInFocus[0];
                    }

                    //more then one apron selected
                    if (this.apronInFocus.length >= 2) {

                        this.mapKeyValues()

                        this.compare(this.mappedKeyValues.manufacturerIDs, 'model', 'manufacturerID');
                        this.compare(this.mappedKeyValues.apronModelIDs, 'apronModelID');
                        this.compare(this.mappedKeyValues.sizes, 'size');
                        this.compare(this.mappedKeyValues.fabricColorIDs, 'fabricColorID');
                        this.compare(this.mappedKeyValues.ribbonColorIDs, 'ribbonColorID');
                        this.compare(this.mappedKeyValues.productionDates, 'productionDate');
                        this.compare(this.mappedKeyValues.nameOfUsers, 'nameOfUser');
                        this.compare(this.mappedKeyValues.departmentIDs, 'departmentID');
                        this.compare(this.mappedKeyValues.monogramLine1s, 'monogramLine1');
                        this.compare(this.mappedKeyValues.monogramLine2s, 'monogramLine2');
                        this.compare(this.mappedKeyValues.internalMaterials, 'internalMaterial');
                        this.compare(this.mappedKeyValues.pbEqBacks, 'pbEqBack');
                        this.compare(this.mappedKeyValues.pbEqFronts, 'pbEqFront');

                        this.countUniqueProps();
                    }
                }
                this.blnLoadingData = false;
            },
            compare: function (selectedValues, prop, nestedProp) {

                this.blnMountDone = false

                //check if all values are the same and set value in emptyApron to this value
                if (nestedProp) {

                    if (selectedValues.every((val, i, arr) => val === arr[0])) {
                        this.emptyApron[prop][nestedProp] = selectedValues[0]
                        return
                    }
                } else {

					if ((prop == 'pbEqBack' || prop === 'pbEqFront') && distinct(selectedValues).length > 1) {
						this.emptyApron[prop] = -2
						return;
                    }

					if ((prop == 'size') && distinct(selectedValues).length > 1) {
						this.emptyApron[prop] = -2
						return;
					}

                    if (selectedValues.every((val, i, arr) => val === arr[0])) {
						if (prop == 'productionDate' && selectedValues[0] != "Undefined") {
							this.emptyApron[prop] = new Date(selectedValues[0])
							return;
						} else if (prop == 'productionDate' && selectedValues[0] == "Undefined") {
							this.emptyApron[prop] = undefined
							return;
						}


                        this.emptyApron[prop] = selectedValues[0]
                        return
                    }
                }

				this.blnMountDone = true
            },
            mapKeyValues: function () {
                this.mappedKeyValues.manufacturerIDs = this.apronInFocus.map(el => el.model.manufacturerID)
                this.mappedKeyValues.manufacturerNames = this.apronInFocus.map(el => el.model.manufacturer.name)
                this.mappedKeyValues.modelNames = this.apronInFocus.map(el => el.model.name)
                this.mappedKeyValues.apronModelIDs = this.apronInFocus.map(el => el.apronModelID)
                this.mappedKeyValues.sizes = this.apronInFocus.map(el => el.size)
                this.mappedKeyValues.fabricColorIDs = this.apronInFocus.map(el => el.fabricColorID)
                this.mappedKeyValues.fabricColorIDs = this.apronInFocus.map(el => el.fabricColorID)
                this.mappedKeyValues.ribbonColorIDs = this.apronInFocus.map(el => el.ribbonColorID)
                this.mappedKeyValues.productionDates = this.apronInFocus.map(el => el.productionDate.slice(0, 7))
                this.mappedKeyValues.nameOfUsers = this.apronInFocus.map(el => el.nameOfUser)
                this.mappedKeyValues.departmentIDs = this.apronInFocus.map(el => el.departmentID)
                this.mappedKeyValues.monogramLine1s = this.apronInFocus.map(el => el.monogramLine1)
                this.mappedKeyValues.monogramLine2s = this.apronInFocus.map(el => el.monogramLine2)
                this.mappedKeyValues.internalMaterials = this.apronInFocus.map(el => el.internalMaterial)
                this.mappedKeyValues.pbEqBacks = this.apronInFocus.map(el => el.pbEqBack)
                this.mappedKeyValues.pbEqFronts = this.apronInFocus.map(el => el.pbEqFront)

                //sizes
                this.mappedKeyValues.sizeByString = []
                this.mappedKeyValues.sizes.forEach(el => {
                    const size = SizeToString(el);
                    this.mappedKeyValues.sizeByString.push(size);
                });

                //filter fabric color names
                const fabricColorsByName = this.apronInFocus.filter(el => {
                    if (el.fabricColor == null) {
                        el.fabricColor = {};
                        return el.fabricColor.name = this.$t('general.unknown')
                    } else {
                        return el.fabricColor.name
                    }
                })

                this.mappedKeyValues.fabricColorNames = fabricColorsByName.map(el => el.fabricColor.name)

                //filter ribbon color names
                const ribbonColorsByName = this.apronInFocus.filter(el => {
                    if (el.ribbonColor == null) {
                        el.ribbonColor = {};
                        return el.ribbonColor.name = this.$t('general.unknown')
                    } else {
                        return el.ribbonColor.name
                    }
                })

                this.mappedKeyValues.ribbonColorNames = ribbonColorsByName.map(el => el.ribbonColor.name)

                //filter departmentNames
                this.mappedKeyValues.departmentNames = []

                this.mappedKeyValues.departmentIDs.forEach((el) => {
                    if (el == null) {
                        el = {}
                        this.mappedKeyValues.departmentNames.push(this.$t('general.unknown'))
                    } else {
                        //const result = this.lstDepartments.find(x => x.departmentID === el)
                        const result = this.lstDepartments.find(x => x.departmentID === el)
                        this.mappedKeyValues.departmentNames.push(result.name)
                    }
                })

                //material
                this.mappedKeyValues.materialsByString = []

                this.mappedKeyValues.internalMaterials.forEach(el => {
                    const material = MaterialToString(el);
                    this.mappedKeyValues.materialsByString.push(material);
                });

                //pbEqFront
                this.mappedKeyValues.pbEqFrontByString = []

                this.mappedKeyValues.pbEqFronts.forEach(el => {
                    const pb = PbEqToString(el);
                    this.mappedKeyValues.pbEqFrontByString.push(pb);
                });

                //pbEqBack
                this.mappedKeyValues.pbEqBackByString = []

                this.mappedKeyValues.pbEqBacks.forEach(el => {
                    const pb = PbEqToString(el);
                    this.mappedKeyValues.pbEqBackByString.push(pb);
                });

                //Clean up production date 
				this.mappedKeyValues.productionDates = this.mappedKeyValues.productionDates.map(function (item) { return item == "0001-01" ? "Undefined" : item; });

            },
            countUniqueProps: function () {

                //collect all the values in an array and count the equal values and put that in an object
                this.selectedUniquePropValues.manufacturers = this.mappedKeyValues.manufacturerNames.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.models = this.mappedKeyValues.modelNames.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.sizes = this.mappedKeyValues.sizeByString.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.fabricColors = this.mappedKeyValues.fabricColorNames.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.ribbonColors = this.mappedKeyValues.ribbonColorNames.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.productionDates = this.mappedKeyValues.productionDates.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.users = this.mappedKeyValues.nameOfUsers.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.departments = this.mappedKeyValues.departmentNames.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.monogramLines1 = this.mappedKeyValues.monogramLine1s.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.monogramLines2 = this.mappedKeyValues.monogramLine2s.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.materials = this.mappedKeyValues.materialsByString.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.pbEqFront = this.mappedKeyValues.pbEqFrontByString.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
                this.selectedUniquePropValues.pbEqBack = this.mappedKeyValues.pbEqBackByString.reduce((cntVal, curVal) => (cntVal[curVal] = cntVal[curVal] + 1 || 1, cntVal), {})
            },
            async setModelToDefault() {

                this.apronInFocus.forEach(el => {
                    //check if the selected manufacturer is different from the aproninfocus
                    if (el.model.manufacturerID != this.emptyApron.model.manufacturerID) {

                        //set default 'other' as modelID
                        const result = this.$store.state.lstModelsForManufacturer.find(x => x.name === 'Other')
                        el.model = result
                        el.apronModelID = result.apronModelID;

                        this.emptyApron.apronModelID = result.apronModelID
                        this.emptyApron.model = result
                        //show warning
                        this.blnShowWarning = true
                    }
                })
            },
        },
        computed: {
            blnMultiEdit: function () {
				return this.apronInFocus.length > 1
            },
            blnIsScanflex: function () {
				return this.emptyApron.model.manufacturerID == 1
            },
            allowSave: function () {

                if (typeof this.emptyApron.model == 'undefined') {
                    return false;
                }

                if (this.blnMultiEdit) {
                    let models = [... new Set(this.apronInFocus.map(x => x.apronModelID))]

					if (models.includes(0)) {
                        return false
					}

                } else {
					if (this.emptyApron.model.manufacturerID < 1) {
						return false
					}
                }



                //serial check only if one item is selected
				if (this.blnMultiEdit == false) {

                    if (this.emptyApron.apronModelID < 1) {
                        return false
                    }

                    if (this.emptyApron.serialNumber == null < 1) {
                        return false
                    } else {
                        if (this.emptyApron.serialNumber.length < 1) {
                            return false
                        }
                    }
                }

                return true
            },
            cptPopularManufacturers: function () {
                var returnValue = []
                for (var i = 0; i < this.lstManufacturers.length; i++) {
                    if (this.$store.state.lstAllAprons.filter(x => x.model.manufacturerID == this.lstManufacturers[i].manufacturerID).length > 0) {
                        returnValue.push(this.lstManufacturers[i])
                    }
                }

                return returnValue
            },
            cptProductionDate: {
                get: function () {
                    return toHTML5month(this.emptyApron.productionDate);
                },
                set: function (newContent) {
                    this.emptyApron.productionDate = new Date(newContent).toISOString()
                }
            },
            OnlyOneModel: function () {
                if (!this.$store.state.fabricOptionsActual) {
                    return false
                }

                return this.$store.state.lstModelsForManufacturer.length == 1
            },
            cptUncategorized: function () {
                return this.lstModelsForManufacturer.filter(x => x.category == 0)
            },
            cptAprons: function () {
                return this.lstModelsForManufacturer.filter(x => x.category == 1 || x.category == 2)
            },
            cptAccessories: function () {
                return this.lstModelsForManufacturer.filter(x => x.category == 3)
            },
            cptNumberOfSelectedFabrics: function () {
				return [... new Set(this.apronInFocus.map(item => item.fabricColorID))].length
            },
			cptNumberOfSelectedRibbons: function () {
				return [... new Set(this.apronInFocus.map(item => item.ribbonColorID))].length
			},
            ...mapState({
                lstManufacturers: state => state.lstManufacturers,
                lstModelsForManufacturer: state => state.lstModelsForManufacturer,
                lstDepartments: state => state.lstDepartments,
                lstFabricColors: state => state.lstFabricColors,
                lstRibbonColors: state => state.lstRibbonColors,
                fabricOptionsActual: state => state.fabricOptionsActual,
                modelsActual: state => state.modelsActual
            }),
        },
        watch: {
			'emptyApron.model.manufacturerID': async function (newValue, oldValue) {
                //Get models by manufacturer
                await this.$store.dispatch('GET_ApronModelsByManufacturer', newValue)

				if (newValue == oldValue) {
                    return;
				}

                if (this.blnMountDone) {
                    let uniqueManufs = distinct(this.apronInFocus.map(x => x.model.manufacturerID))

                    if (uniqueManufs.length == 1) {
                        if (uniqueManufs[0] != newValue) {
							this.apronInFocus.forEach(x => {
								x.model.manufacturerID = newValue;
								x.model.apronModelID = -1
							});
                        }
                    } else {
						this.apronInFocus.forEach(x => {
							x.model.manufacturerID = newValue;
							x.model.apronModelID = -1
						});
                    }

                    this.emptyApron.apronModelID = -1;
				}
              
                await this.setModelToDefault()

                if (newValue != 1 && newValue != 0) {
                    //Reset fabric and ribbon color when the vendor is not scanflex

                    this.apronInFocus.forEach(el => {
                        el.fabricColorID = null
                        el.ribbonColorID = null
                        el.internalMaterial = -1
                        el.monogramLine2 = ''
                    });
                }

                //if (oldValue != 0 && newValue != 0) {
                //    //Reset model in case the manufacturer was changed from its original value

                //    this.apronInFocus.forEach(el => {
                //        el.apronModelID = 0
                //    });
                //}
            },
            'emptyApron.apronModelID': async function (newValue) {
                //Get colors by model
                await this.$store.dispatch('GET_ApronColorsByModelID', newValue)

				if (newValue != -1) {
					//Apply to ApronInFocus
					if (this.$store.state.modelsActual) {
						var myModels = this.lstModelsForManufacturer.filter(x => x.apronModelID == newValue)
						this.apronInFocus.forEach(el => {
							el.apronModelID = newValue
							if (myModels.length > 0) {
								el.model = myModels[0]
							} else {
								console.log('Error: model unknown')
							}
						});
					}
				}
				
            },
            'emptyApron.fabricColorID': function (newValue) {

                if (this.fabricOptionsActual == false) {
                    //Not loaded yet
                    return;
                }

                //Reset ribbon if no ribbons available
                if (this.lstRibbonColors == null) {
                    this.emptyApron.ribbonColorID = null
                } else if (this.lstRibbonColors.length == 0) {
                    this.emptyApron.ribbonColorID = null
                }

                //Apply to apronInFocus
				var myColours = this.lstFabricColors.filter(x => x.fabricColorID == newValue)
				this.apronInFocus.forEach(el => {
                    el.fabricColorID = newValue
					if (myColours.length == 1) {
                        el.fabricColor = myColours[0]
					} else {
						el.fabricColor = null
					}
				});
            },
			'emptyApron.ribbonColorID': function (newValue) {

				if (this.fabricOptionsActual == false) {
					//Not loaded yet
					return;
				}

				//Apply to apronInFocus
				var myColours = this.lstRibbonColors.filter(x => x.ribbonColorID == newValue)
				this.apronInFocus.forEach(el => {
					el.ribbonColorID = newValue
					if (myColours.length == 1) {
						el.ribbonColor = myColours[0]
					} else {
						el.ribbonColor = null
					}
				});
			},
            'emptyApron.departmentID': function (newValue) {
				var myDept = this.lstDepartments.filter(x => x.departmentID == newValue)

                if (myDept.length == 1) {

                    this.apronInFocus.forEach(el => {
                        el.department = myDept[0]
						el.departmentID = newValue
                    });
                } else {
					this.apronInFocus.forEach(el => {
                        el.department = null
						el.departmentID = newValue
					});
                }
            },
            'emptyApron.size': function (newValue) {
                if (newValue == -2) {
                    //Do not propagate
                    return;
                }

                //Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.size = newValue
				});
            },
            'emptyApron.pbEqFront': function (newValue) {
				if (newValue == -2) {
					//Do not propagate
					return;
                }

				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.pbEqFront = newValue
				});
            },
            'emptyApron.pbEqBack': function (newValue) {
				if (newValue == -2) {
					//Do not propagate
					return;
                }

				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.pbEqBack = newValue
				});
			},
			'emptyApron.nameOfUser': function (newValue) {
				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.nameOfUser = newValue
				});
            },
			'emptyApron.monogramLine1': function (newValue) {
				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.monogramLine1 = newValue
				});
            },
			'emptyApron.monogramLine2': function (newValue) {
				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.monogramLine2 = newValue
				});
            },
			'emptyApron.internalMaterial': function (newValue) {
				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.internalMaterial = newValue
				});
            },
			'emptyApron.productionDate': function (newValue) {
				//Apply to all aprons
				this.apronInFocus.forEach(el => {
					el.productionDate = newValue
				});
			},
            OnlyOneModel: function (newValue) {
                if (newValue) {
                    this.emptyApron.apronModelID = this.$store.state.lstModelsForManufacturer[0].apronModelID
                }
            }
        }
    }

	function distinct(a) {
		return [...new Set(a)];
	}
</script>